export const FT_SELF_RANGE_ID = 'D82855E1-4BB9-93EA-6374-B9904318BC1D';

const CONTESTING_ROLL_ID = 'AD80D31D-898B-66CE-0894-1335D11B1529';
const HARMFUL_ROLL_TYPE_IDS = new Set([
    '82BBB3B6-4646-48E8-A5A2-8DC0947A91D0', // Damage Roll
    '77A044B7-7041-CA96-3C63-BB718B15A364', // Damage Over Time Roll
    '5740CA49-006E-A7A0-B46B-6DDED6CD546C', // Spell Melee Attack Roll
    'DD280A3B-6F1D-4CE9-9EFD-505A74D0C07C', // Spell Ranged Attack Roll
    '2FE8DFB7-FE61-4862-AF71-3523262350A0', // Weapon Melee Attack Roll
    '3F85CA97-F9B2-A83A-FDE8-E523FD99346C', // Weapon Ranged Attack Roll
    '436DF799-6B13-4A6E-AC7C-DA577C36E437',
    CONTESTING_ROLL_ID,
]);

export interface AoeCasterExclusionInput {
    range?: unknown;
    shape?: unknown;
    rollType?: unknown;
    itemType?: unknown;
    dice?: unknown;
    die?: unknown;
    persistent?: unknown;
    followsTarget?: unknown;
}

function values(value: unknown): string[] {
    if (Array.isArray(value)) return value.flatMap(values);
    return String(value ?? '').split(',').map(part => part.trim().toUpperCase()).filter(Boolean);
}

function enabled(value: unknown): boolean {
    if (Array.isArray(value)) return value.some(enabled);
    return value === true || value === 1 || String(value ?? '').trim() === '1';
}

function positive(value: unknown): boolean {
    if (Array.isArray(value)) return value.some(positive);
    const numeric = Number(value);
    return Number.isFinite(numeric) && numeric > 0;
}

/**
 * Self lines/cones and damaging/contesting self-range areas must not target their caster. Sustained centred self auras are the
 * deliberate exception: they are attached buff/effect fields, not a one-shot blast. The attack-AOE
 * branch preserves the legacy XZ rule for non-persistent attack abilities regardless of cast range.
 */
export function aoeExcludesCaster(input: AoeCasterExclusionInput): boolean {
    const persistent = enabled(input.persistent);
    const followsTarget = enabled(input.followsTarget);
    const itemType = String(input.itemType ?? '').trim().toLowerCase();
    const attackAoe = !persistent
        && (itemType === 'attack_ability' || itemType === 'opportunity_attack_ability');
    const selfRange = values(input.range).includes(FT_SELF_RANGE_ID);
    const directional = values(input.shape).some(shape => ['LINE', 'CONE',
        '56D1C490-B589-4B17-889A-59D866E38D54', '0FEF0148-6B62-4601-A8A1-A5A1A22905D8'].includes(shape));
    const harmfulRoll = values(input.rollType).some(id => HARMFUL_ROLL_TYPE_IDS.has(id));
    const damaging = positive(input.dice) && positive(input.die);
    const aura = persistent && followsTarget;
    return attackAoe || (selfRange && (directional || (!aura && (harmfulRoll || damaging))));
}
